// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/vor-instruments.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/vor-instruments/vor-instruments.js';

mount([g0]);
